'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function GTMPageView() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: pathname + window.location.search,
      page_title: document.title,
    });
  }, [pathname]);

  return null;
}